export default class FieldViewConfiguration {
    constructor() {
        this.fieldViews = {};
    }

    registerFieldView(type, FieldView) {
        this.fieldViews[type] = FieldView;
    }

    $get() {
        return this.fieldViews;
    }
}

FieldViewConfiguration.$inject = [];



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Crud/fieldView/FieldViewConfiguration.js